import React, { useState } from "react";
import SkeyeformUsersTable from "./SkeyeformUsersTable";
import {
  AddUserDialog,
  //EditUserDialog,
  EditRoleDialog,
} from "./SkeyeformUsersDialogs";
import {
  fetchUsers,
  createUser,
  //updateUser,
  deleteUser,
  updateUserRole,
} from "./SkeyeformUsersAPI";
import PageLayout from "../../../components/PageLayout";
import SearchToolbar from "../../../components/SearchToolbar";
import usePageTitle from "../../../services/usePageTitle";
import usePageState from "../../../hooks/usePageState";
import useIsRoleUser from "../../../hooks/useIsRoleUser";
import skeyeformUsersHelpContent from "../../../content/help/skeyeform-users.json";

export default function SkeyeformUsers({ pageTitle = "Skeyeform Users" }) {
  usePageTitle("SkeyeForm Users - SkeyeGate™");

  const {
    filteredData,
    loading,
    searchText,
    page,
    pageSize,
    messageApi,
    contextHolder,
    handleSearch,
    clearFilter,
    loadData,
    onPageChange,
  } = usePageState({
    fetchFn: fetchUsers,
    filterFields: ["username", "email"],
  });

  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editUserModalOpen, setEditUserModalOpen] = useState(false);
  const [editRoleModalOpen, setEditRoleModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedRoleLabel, setSelectedRoleLabel] = useState(null);
  const isRoleUser = useIsRoleUser();

  const handleAddUser = async (values) => {
    try {
      const createResponse = await createUser({
        username: values.username,
        email: values.email,
        password: values.password,
        role: values.roleLabel,
      });
      const newUserId = createResponse?.data?.id || createResponse?.id;
      if (newUserId) {
        await updateUserRole(newUserId, values.roleLabel, null);
      }
      messageApi.success("User successfully added.");
      loadData();
    } catch (error) {
      throw error;
    }
  };

  /* const handleEditUser = async (values) => {
    try {
      await updateUser(selectedUser.id, {
        username: values.username,
        email: values.email,
      });
      messageApi.success("User updated successfully.");
      loadData();
    } catch (error) {
      messageApi.error({
        content:
          error.response?.data?.error ||
          error.response?.data?.exception ||
          error.response?.data?.message ||
          error.message ||
          "Failed to update user",
        key: "update-user-error",
      });
      throw error;
    }
  }; */

  const handleEditRole = async (values) => {
    try {
      await updateUserRole(
        selectedUser.id,
        values.roleLabel,
        selectedRoleLabel,
      );
      messageApi.success("Role updated successfully.");
      loadData();
    } catch (error) {
      throw error;
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      await deleteUser(userId);
      messageApi.success("User deleted successfully.");
      loadData();
    } catch (error) {
      messageApi.error({
        content:
          error.response?.data?.error ||
          error.response?.data?.exception ||
          error.response?.data?.message ||
          error.message ||
          "Failed to delete user",
        key: "delete-user-error",
      });
    }
  };

  return (
    <div className="skeyeform-users-page">
      {contextHolder}
      <PageLayout
        title={pageTitle}
        logoSrc="/img/skeyeform_initial_logo.svg"
        description="Manager for Skeyeform users, allowing you to create, edit, and organize your user accounts and permissions in one place."
        helpContent={skeyeformUsersHelpContent}
      >
        <SearchToolbar
          search={searchText}
          onSearchChange={handleSearch}
          onClearFilter={clearFilter}
          addButtonLabel="Add"
          onAdd={() => setAddModalOpen(true)}
          showAdd={!isRoleUser}
        />

        <SkeyeformUsersTable
          data={filteredData}
          loading={loading}
          page={page}
          pageSize={pageSize}
          onPageChange={onPageChange}
          onEditUser={(user) => {
            setSelectedUser(user);
            setEditUserModalOpen(true);
          }}
          onEditRole={(user, roleLabel) => {
            setSelectedUser(user);
            setSelectedRoleLabel(roleLabel);
            setEditRoleModalOpen(true);
          }}
          onDeleteUser={handleDeleteUser}
          isRoleUser={isRoleUser}
        />
      </PageLayout>

      <AddUserDialog
        open={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        onSave={handleAddUser}
      />
      {/*       <EditUserDialog
        open={editUserModalOpen}
        user={selectedUser}
        onClose={() => setEditUserModalOpen(false)}
        onSave={handleEditUser}
      /> */}
      <EditRoleDialog
        open={editRoleModalOpen}
        user={selectedUser}
        currentRoleLabel={selectedRoleLabel}
        onClose={() => setEditRoleModalOpen(false)}
        onSave={handleEditRole}
      />
    </div>
  );
}
